// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import fetchClient from '@/graphql/fetchMutation';
import fetchServer from '@/graphql/fetchQuery';
import gql from '@/graphql/gql';
import { TournamentFragmentDoc } from '../../../../../shared/graphql/TournamentFragment.generated';
export type TournamentOptInMutationVariables = Types.Exact<{
  tournamentId: Types.Scalars['String']['input'];
  newValue: Types.Scalars['Boolean']['input'];
  currency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TournamentOptInMutation = { __typename?: 'Mutation', casinoTournamentsPublicSetOptInMutation?: { __typename?: 'CasinoTournamentsPublicSetOptInMutationPayload', success?: boolean, errors?: Array<{ __typename?: 'CasinoTournamentsPublicError', message?: string }>, tournament?: { __typename?: 'CasinoTournamentsPublicTournament', id: string, enabled?: boolean, openAt?: any, closeAt?: any, iAmOptedIn?: boolean, name?: string, prizeText?: string, activityType?: string, shortUrl?: string, backgroundImageSmall?: string, backgroundImageLarge?: string, rules?: string, leaderboardType?: string, myScore?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> }, prizes?: Array<{ __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, automaticallyReleased?: boolean }>, leaderboard?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> } } };


export const TournamentOptInMutationDocument = gql`
    mutation TournamentOptInMutation($tournamentId: String!, $newValue: Boolean!, $currency: String) {
  casinoTournamentsPublicSetOptInMutation(
    input: {tournamentId: $tournamentId, newValue: $newValue, currency: $currency}
  ) {
    errors {
      message
    }
    success
    tournament {
      ...TournamentFragment
    }
  }
}
    ${TournamentFragmentDoc}`;

export const getTournamentOptInMutation = async (variables: TournamentOptInMutationVariables) => {
  return fetchClient<TournamentOptInMutation, TournamentOptInMutationVariables>(TournamentOptInMutationDocument, "TournamentOptInMutation", { variables });
}
export const getTournamentOptInAction = async (variables: TournamentOptInMutationVariables) => {
  return fetchServer<TournamentOptInMutation, TournamentOptInMutationVariables>(TournamentOptInMutationDocument, "TournamentOptInMutation", { variables });
}